<template>
  <div>
    <div
      v-if="visible"
      class="context-menu"
      :style="{ top: `${position.y}px`, left: `${position.x}px` }"
    >
      <ul>
        <li @click="handleAction('byFolio')">Generar QR por Folio en lugar de PatientId</li>
        <li @click="handleAction('alterFolio')">Indicar con que Folio generar QR</li>
      </ul>
    </div>
    <div class="box">
      <div>
        <select-patient class="columns is-multiline"
                        only-search
                        @selectOrder="setOrder">
        </select-patient>

        <div class="columns">
          <div class="column is-one-quarter">
            <b-field label="Año">
              <b-select expanded v-model="selectedYear">
                <option :value="option.key" v-for="(option, index) in years" :key="index">{{ option.value }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-one-quarter">
            <search-order v-model="search"
                          ref="search_order"
                          @setData="onSetData"
                          :year="selectedYear"
                          :downloadResultsLink="$alfalab.canDownloadResultLink($auth.user())"
                          :withMinasData="$alfalab.canDownloadMinasData($auth.user())"
                          type="order"
            ></search-order>
          </div>
        </div>
      </div>
    </div>

    <div class="box" v-if="hasOrder">
      <div class="columns is-multiline">
        <div style="display: flex; flex-wrap: wrap; gap: 16px; padding: 10px; align-items: center;">
          <b-tooltip
            v-if="false && $alfalab.enabledUploadMaquila($auth.user())"
            label="Carga de PDF Maquila">
            <b-button
              type="is-primary"
              @click="showPDFMaquila = true"
              icon-left="laptop-medical"></b-button>
          </b-tooltip>
          <b-tooltip
              v-if="$alfalab.enableUploadExtraMedia($auth.user())"
              label="Carga de archivos adicionales">
            <b-button
                type="is-primary"
                @click="handleExtraMedia"
                icon-left="laptop-medical"></b-button>
          </b-tooltip>

        </div>
        <div class="column is-12">
          <p>Paciente: {{ order.patient.full_name }}</p>
          <div class="cancel_message">
            <b-message type="is-danger" v-if="order.is_cancel">
              Orden Cancelada
            </b-message>
          </div>
        </div>
        <div class="column">
          <b-field label="Email">
            <b-input v-model="email"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="" class="">
            <b-button class="is-primary" @click="onSendMail" expanded>Enviar Todos</b-button>
          </b-field>
        </div>
        <div class="column">
          <b-field label="">
            <b-button class="" expanded @click="onPrint">Imprimir Seleccionados</b-button>
          </b-field>
        </div>
      </div>
      <div class="columns is-multiline" v-if="$alfalab.canDownloadResultLink($auth.user())">
        <div class="column is-4">
          <b-field label="Tamaño de letra">
            <b-input type="number" v-model="fontSize"></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns is-multiline">
        <div class="column is-3-desktop is-2-widescreen" v-for="item in results">
          <div class="card">
            <div class="card-image">

            </div>
            <div class="card-content text-center">
              <figure class="image">
                <b-checkbox v-model="selected[item.type]"
                >
                  <img :src="item.img" :alt="item.title">
                </b-checkbox>
              </figure>
              <h3 v-if="!!item.study_name" class="subtitle">{{ item.study_name }}</h3>
              <h3 class="subtitle" v-if="!$alfalab.canDownloadResultLink($auth.user())">{{ item.title }}</h3>
              <h3 class="subtitle" v-else>Descargar: <a :href="item.url" target="_blank"
                                                        type="octet/stream">{{ item.title }}</a></h3>
              <div class="is-flex is-flex-direction-column">
                <a
                  v-if="$alfalab.allowImagingModule($auth.user())"
                  @click="handleShowLabel(item.sample_id)"
                  @contextmenu.prevent="openMenu"
                  style="display: block; font-weight: bold; margin: 0 auto;width: 100%; text-align: center"
                  :data-code-value="item.sample_code">
                  {{ item.sample_code }}
                </a>
                <a
                  v-else
                  @click="handleShowLabel(item.sample_id)"
                  style="display: block; font-weight: bold; margin: 0 auto;width: 100%; text-align: center">
                  {{ item.sample_code }}
                </a>
                <button class="custom-button" v-if="$alfalab.canDownloadResultLink($auth.user()) && item.action" @click="() => verPDFsinMembrete(item)">Ver sin
                  membrete
                </button>
                <button v-if="$alfalab.canGenerateDocument($auth.user(), item)" @click="() => runAction(item)">Volver a
                  generar documento
                </button>
                <button v-if="item.can_delete && $alfalab.enabledUploadMaquila($auth.user())" class="button  is-primary"
                        @click="() => deleteAction(item)">Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3-desktop is-2-widescreen" v-if="order.minas_data && order.minas_data.quizes">
          <div class="card">
            <div class="card-image"></div>
            <div class="card-content text-center">
              <figure class="image">
                <img :src="order.minas_data.quizes.img" alt="Cuestionarios Minas">
              </figure>
            <h3 class="subtitle">Descargar: <a :href="order.minas_data.quizes.url" target="_blank">Cuestionarios Minas</a></h3>
            </div>
          </div>
        </div>
        <div class="column is-3-desktop is-2-widescreen" v-if="order.minas_data && order.minas_data.quizes_v2">
          <div class="card">
            <div class="card-image"></div>
            <div class="card-content text-center">
              <figure class="image">
                <img :src="order.minas_data.quizes_v2.img" alt="Cuestionario Psicosocial Minas">
              </figure>
              <h3 class="subtitle">Descargar: <a :href="order.minas_data.quizes_v2.url" target="_blank">Cuestionario Psicosocial Minas</a></h3>
            </div>
          </div>
        </div>
        <div class="column is-3-desktop is-2-widescreen" v-if="order.minas_data && order.minas_data.oit">
          <div class="card">
            <div class="card-image"></div>
            <div class="card-content text-center">
              <figure class="image">
                <img :src="order.minas_data.oit.img_es" alt="OIT Español">
              </figure>
              <h3 class="subtitle">Descargar: <a :href="order.minas_data.oit.url_es" target="_blank">OIT Español</a></h3>
            </div>
          </div>
        </div>
        <div class="column is-3-desktop is-2-widescreen" v-if="order.minas_data && order.minas_data.oit">
          <div class="card">
            <div class="card-image"></div>
            <div class="card-content text-center">
              <figure class="image">
                <img :src="order.minas_data.oit.img_en" alt="OIT Inglés">
              </figure>
              <h3 class="subtitle">Descargar: <a :href="order.minas_data.oit.url_en" target="_blank">OIT Inglés</a></h3>
            </div>
          </div>
        </div>
        <div class="column is-3-desktop is-2-widescreen" v-if="order.cemex_data">
          <div class="card">
            <div class="card-image"></div>
            <div class="card-content text-center">
              <figure class="image">
                <img :src="order.cemex_data.img" :alt="order.cemex_data.title">
              </figure>
              <h3 class="subtitle">Descargar: <a :href="order.cemex_data.url" :target="order.cemex_data.img">{{order.cemex_data.title}}</a></h3>
            </div>
          </div>
        </div>
      </div>
      <template v-if="$alfalab.isAdmin($auth.user()) && order.order_new && awsDocuments.length">
        <div>
          <hr>
          <h2>Documentos de resultados almacenados en AWS</h2>
          <div class="columns is-multiline">
            <div v-for="(item, index) in awsDocuments" :key="index">
              <a :href="item.backendUrl"
                 target="_blank"
                 class="column is-3">{{ item.basename }}</a>
            </div>
          </div>
        </div>
      </template>
    </div>
    <b-modal v-model="showPDFMaquila">
      <maquila-modal :order="order" @reload="onReload" />
    </b-modal>
    <b-modal v-model="showModalPdfWithoutMembrete">
      <iframe class="lapi__iframe"
              :src="pdfUrl"></iframe>
    </b-modal>

    <b-modal v-model="showLabel">
      <figure class="image">
        <img alt="label" :src="urlLabelary" class="labelary-image" />
      </figure>
    </b-modal>
  </div>
</template>

<script>
import SelectPatient from "../../components/patient/SelectPatient";
import SearchOrder from "../../components/order/SearchOrder";
import MaquilaModal from "../../components/maquila/MaquilaModal.vue";
import ResultsExtraMediaFinder from "../../components/results/ResultsExtraMediaFinder.vue";

export default {
  name: "IndexResult",
  components: { MaquilaModal, SearchOrder, SelectPatient },
  data() {
    return {
      apiUrl: "orders",
      order: {},
      data: [],
      hasOrder: false,
      url: process.env.VUE_APP_URL,
      results: [],
      search: "",
      email: "",
      selectedYear: (new Date().getFullYear() % 10) + "",
      selected: {},
      awsDocuments: {},
      showPDFMaquila: false,
      showModalPdfWithoutMembrete: false,
      pdfUrl: null,
      visible: false,
      position: { x: 0, y: 0 },
      codeSelected: null,
      fontSize: "12",
      showLabel: false,
      zplCode: '',
    };
  },
  computed: {
    year() {
      return this.$store.state.main.year || "0";
    },
    years() {
      const current = new Date().getFullYear();
      const years = [];
      years.push({ key: (current % 10) + "", value: current });
      years.push({ key: ((current - 1) % 10) + "", value: current - 1 });
      //years.push({key: ((current-2) % 10) + "", value: current-2});
      //years.push({key: ((current-3) % 10) + "", value: current-3});
      // years.push({key: ((current-2) % 10) + "", value: current-2});
      return years;
    },
    urlLabelary(){
      return `https://api.labelary.com/v1/printers/8dpmm/labels/2.25x.95/0/${this.zplCode}`
    }
  },
  methods: {
    onSelectPatient(data) {
      this.getAll({
        patient: data.code
      });
    },
    onSetData(data) {
      //console.log(data);
      this.awsDocuments = [];
      this.hasOrder = true;
      this.order = data;
      this.email = this.order.patient.email;
      this.results = data.results || [];
      this.selected = {};
      this.getAWSDocuments();
    },
    getUrl(type) {

    },
    getAWSDocuments() {
      this.$http.get(`/orders-aws/results/${this.order.order_new}`).then(({ data }) => {
        this.awsDocuments = data;
      });
    },
    async setOrder(data) {
      this.selectedYear = String(data.order_new).substr(0, 1);
      this.search = String(data.no);
      this.hasOrder = false;
      this.$loader.show();
      setTimeout(async () => {
        await this.$refs.search_order.searchOrder();
        this.$store.dispatch("setShowModalSelectPatient", false);
        this.$loader.hide();
        this.selected = {};
      }, 500);
    },
    onSendMail() {
      if (this.email) {
        this.$loader.show();
        this.$http.post(`/order-results/${this.order.order_new}/email`,
          {
            email: this.email
          }
        ).then(({ data }) => {
          this.$toast.success(data.message);
        }).catch(errors => {
          this.$alfalab.showError(errors);
        }).finally(() => {
          this.$loader.hide();
        });
      } else {
        this.$toast.error("Se debe especificar un email");
      }

    },
    onPrint() {
      this.$loader.show();
      this.$http.post(`/order-results/${this.order.order_new}/print`, {
        selected: this.selected,
        printer: (Number.parseInt(localStorage.getItem("printerManager_printer")) || 1)
      }).then(({ data }) => {
        this.$toast.success(data.message);
      }).catch(errors => {
        this.$alfalab.showError(errors);
      }).finally(() => {
        this.$loader.hide();
      });
    },
    runAction(item) {
      this.$loader.show();
      this.$http.get(item.action, {
        params: {
          font_size: this.fontSize ? this.fontSize + "px" : null
        }
      }).then(() => {
        this.$toast.success("Acción realizada con éxito");
      }).catch(error => {
        this.$alfalab.showError(error);
      }).finally(() => {
        this.$loader.hide();
      });
    },
    async verPDFsinMembrete(item) {
      this.$loader.show();
      try {
        const response = await this.$http.get(`${item.action}?preview&without-background`, {
          responseType: "blob",
          params: {
            font_size: this.fontSize ? this.fontSize + "px" : null
          }
        }).finally(() => {
          this.$loader.hide();
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
        this.showModalPdfWithoutMembrete = true;
      } catch (error) {
        console.error("Error al descargar PDF:", error);
      }
    },
    onReload() {
      this.$refs.search_order.onSearch();
    },
    deleteAction(item) {
      console.log("item", item);
      this.$buefy.dialog.confirm({
        title: "Borrar documento de Maquila",
        message: "¿Estás seguro de que deseas borrar este documento de Maquila?",
        confirmText: "Si, borrar",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$loader.show();
          this.$http.delete(`/order/${this.order.id}/${item.result_id}/maquila`).then(({ data }) => {
            this.$buefy.dialog.alert({
              title: "Acción realizada con éxito",
              message: "Elemento eliminado",
              confirmText: "Aceptar"
            });
          }).catch(errors => {
            this.$alfalab.showError(errors);
          }).finally(() => {
            this.$refs.search_order.onSearch();
            this.$loader.hide();
          });
        }
      });
    },
    openMenu(event) {
      this.position = { x: event.clientX, y: event.clientY };
      this.visible = true;
      this.codeSelected = event.target.getAttribute("data-code-value");
      // Cerrar menú al hacer click fuera
      document.addEventListener("click", this.closeMenu);
    },
    closeMenu() {
      this.visible = false;
      document.removeEventListener("click", this.closeMenu);
    },
    handleAction(action) {
      this.visible = false;
      document.removeEventListener("click", this.closeMenu);
      if (action === "byFolio") {
        this.$loader.show();
        this.$http.post("eden/alter-code", {
          code: this.codeSelected,
          alter: this.codeSelected
        }).finally(() => {
          this.$loader.hide();
        });
      } else if (action === "alterFolio") {
        this.$buefy.dialog.prompt({
          title: "Indicar Folio",
          message: "Indica el folio con el que se generará el QR",
          confirmText: "Generar",
          cancelText: "Cancelar",
          inputAttrs: {
            type: "text",
            placeholder: "Folio"
          },
          onConfirm: (folio) => {
            if (folio) {
              this.$loader.show();
              this.$http.post("eden/alter-code", {
                code: this.codeSelected,
                alter: folio
              }).then(({ data }) => {
                this.$toast.success(data.message);
              }).catch(errors => {
                this.$alfalab.showError(errors);
              }).finally(() => {
                this.$loader.hide();
              });
            }
          }
        });
      }
    },
    handleShowLabel(sampleId) {
      this.$loader.show();
      console.log(sampleId);
      this.$http.get(`/labels/${sampleId}/zpl`).then(({ data }) => {
        this.zplCode = data.zpl_code;
        this.showLabel = true;
      }).catch(errors => {
        this.$alfalab.showError(errors);
      }).finally(() => {
        this.$loader.hide();
      });
    },
    handleExtraMedia(){
      this.$buefy.modal.open({
        parent: this,
        component: ResultsExtraMediaFinder,
        hasModalCard: true,
        canCancel: false,
        customClass: 'custom-class custom-class-2',
        trapFocus: true,
        props: {
          order: this.order
        },
        fullScreen: true
      })
    }
  }
};
</script>

<style scoped>
.custom-button {
  background-color: #0396A6;
  border: none;
  color: white;
  padding: 10px 0;
  margin: 10px auto;
  cursor: pointer;
  border-radius: 4px;
}

.custom-button:hover {
  background-color: #027a8c;
}

.lapi__iframe {
  width: 100%;
  height: 80vh;
}

.context-menu {
  position: fixed;
  z-index: 1000;
  background: white;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  min-width: 120px;
}

.context-menu ul {
  list-style: none;
  margin: 0;
  padding: 5px 0;
}

.context-menu li {
  padding: 8px 16px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #f0f0f0;
}

.labelary-image {
  width: 80vw;
  max-width: 600px;
  margin: 0 auto;
}

.text-center {
  text-align: center;
}
</style>
